import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { LanguageActions } from './language.actions';
import { SUPPORTED_LANGUAGE } from './language.model';
import { LanguageSelectors } from './language.selectors';

@Injectable({ providedIn: 'root' })
export class LanguageStore {
  state$ = this.store.select(LanguageSelectors.selectState());
  languageCode$ = this.store.select(LanguageSelectors.selectLanguageCode());
  isLoaded$ = this.store.select(LanguageSelectors.selectIsLoaded);

  constructor(private store: Store) {}

  getLanguage(languageCode?: SUPPORTED_LANGUAGE): void {
    this.store.dispatch(LanguageActions.getLanguage({ languageCode }));
  }

  setLanguage(languageCode: SUPPORTED_LANGUAGE): void {
    this.store.dispatch(LanguageActions.setLanguage({ languageCode }));
  }
}
